import { Box, styled } from '@material-ui/core';

export const ProfileCheckBoxContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
}));

export const CheckBoxContainer = styled(Box)(({ theme }) => ({
  width: '20px',
  position: 'relative',
  height: '20px',
}));

export const AbsouluteContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: -9,
  left: -20,
  fontSize: '25px',
}));
